<body>
  <div class="page-topbar">
    <app-topnavbar #topNavbar></app-topnavbar>
  </div>
  <div class="page-container row-fluid">
    <div class="page-sidebar" [ngClass]="{'collapseit':menuFolded,'expandit':!menuFolded}">
      <app-sidebar></app-sidebar>
    </div>
    <section id="main-content" #maincontent [ngClass]="{'sidebar_shift':menuFolded}">
      <div class="pull-left
      mobile-pagetitle">
        <h1 class="ng-binding">Account Management</h1>
      </div>
      <section class="wrapper main-wrapper">
        <div class="content-wrapper" id="content-wrapper">
          <router-outlet></router-outlet>
        </div>
      </section>
    </section>
  </div>
</body>
